export enum DirectPaymentStage {
  VerifyIdentity = 0,
  ChoosePaymentAmount = 1,
  PaymentDetails = 2,
}
